import React, { ElementRef, memo, useEffect, useRef, useState } from 'react';
import { InputContainer, StyledInput } from '../../styles';

interface iTableInputProps {
  id: number;
  minimum?: number;
  maximum?: number;
  isFocused: boolean;
  placeholder?: string;
  isDisabled?: boolean;
  type?: 'text' | 'number';
  value: string | number | null;
  defaultValue?: string | number;
  onFocus?: () => void;
  handleBlurIndexReset?: () => void;
  onBlur?: (value: number | null) => void;
  onChange?: (value: number | string | null) => void;
}

const TableInput: React.FC<iTableInputProps> = memo(
  ({
    onChange,
    onFocus,
    onBlur,
    defaultValue,
    placeholder,
    isDisabled,
    isFocused,
    minimum,
    value,
    type,
    id,
  }) => {
    const inputRef = useRef<ElementRef<'input'>>(null);
    const [inputValue, setInputValue] = useState<string | number | null>(
      defaultValue ?? ''
    );

    useEffect(() => {
      setInputValue(value ?? '');
    }, [value]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      // eslint-disable-next-line no-shadow
      let { value } = e.target;

      value = value.replace(',', '.');

      const transformeValue = String(value);

      setInputValue(value);

      if (onChange) onChange(transformeValue);

      return inputValue;
    };

    useEffect(() => {
      if (isFocused) {
        inputRef.current?.focus();
      }
    }, [isFocused]);

    const handleBlur = () => {
      if (onBlur) {
        const numberValue =
          typeof inputValue === 'string' ? parseFloat(inputValue) : inputValue;
        onBlur(numberValue);
      }
    };

    const isMinimum = () => {
      handleBlur();

      if (minimum) {
        if (inputValue) {
          if (minimum > +inputValue) {
            setInputValue(minimum);
            return;
          }
        }
        setInputValue(minimum);
      }
    };

    return (
      <InputContainer>
        <StyledInput
          onChange={handleInputChange}
          type={type || 'number'}
          ref={inputRef}
          placeholder={placeholder || 'Editar'}
          onFocus={onFocus}
          value={inputValue !== null ? inputValue : ''}
          onBlur={() => {
            isMinimum();
          }}
          disabled={isDisabled}
          id={String(id)}
        />
      </InputContainer>
    );
  }
);

export default memo(TableInput);
